<cdk-virtual-scroll-viewport
  [hidden]="dataIsLoading"
  [itemSize]="TYPICAL_COL_HEIGHT"
  [ngClass]="{ 'fixed-scroll': isInjected }"
  [style.zoom]="zoom()"
>
  <cdk-virtual-scroll-viewport-wrapper>
    <table
      id="incidents-table"
      class="main-table"
      [dataSource]="dataSource"
      [multiTemplateDataRows]="true"
      [trackBy]="trackBy"
      #table
      mat-table
      matSort
    >
      <!--- Note that these columns can be defined in any order.
                    The actual rendered columns are set as a property on the row definition" -->

      <!-- Number Column -->
      <ng-container
        [matColumnDef]="IncidentColumn.INDEX"
        [sticky]="!isMobile"
      >
        <th
          *matHeaderCellDef
          mat-header-cell
        >{{ staticIncidentColumnTitle[IncidentColumn.INDEX] }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          {{ dataSourceIndex[element.id] }}
        </td>
      </ng-container>

      <!-- Ticket Number Column -->
      <ng-container
        [matColumnDef]="IncidentColumn.TICKET_NUMBER"
        [sticky]="!isMobile"
      >
        <th
          class="table-border-last-left-sticky"
          [ngClass]="{ 'left-10': !isMobile }"
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
          sortActionDescription="Sort by ticker number"
        >
          {{ staticIncidentColumnTitle[IncidentColumn.TICKET_NUMBER] }}
        </th>
        <td
          class="table-border-last-left-sticky test-ticket-number"
          [ngClass]="{ 'left-10': !isMobile }"
          *matCellDef="let element"
          mat-cell
        >
          <a
            [class.underline]="!isReportMode"
            [routerLink]="isReportMode ? null : ['/incidents', element.id]"
          >
            {{ element.ticketNumber }}
          </a>
        </td>
      </ng-container>

      <!-- Status Column -->
      <ng-container [matColumnDef]="IncidentColumn.STATUS">
        <th
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
          sortActionDescription="Sort by severity"
        >
          {{ incidentColumnTitle[IncidentColumn.STATUS] }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          <div class="flex gap-1">
            <avs-incident-severity-icon [severity]="element.severity" />
            <span class="capitalize">{{ element.severity }}</span>
          </div>
        </td>
      </ng-container>

      <!-- Device Name Column -->
      <ng-container [matColumnDef]="IncidentColumn.DEVICE_ID">
        <th
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
          sortActionDescription="Sort by device name"
        >
          {{ incidentColumnTitle[IncidentColumn.DEVICE_ID] }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          <a
            [class.underline]="!isReportMode"
            [routerLink]="isReportMode ? null : ['/devices', element.buildingId, element.deviceType === 'Network Port' ?element.parentId || element.deviceId : element.deviceId]"
          >
            @if (element.deviceType === 'Network Port') {
              <div>{{ element.parentName }}</div>
            }
            <div>{{ element.deviceName }}</div>
          </a>
        </td>
      </ng-container>

      <!-- Device Type Column -->
      <ng-container [matColumnDef]="IncidentColumn.DEVICE_TYPE">
        <th
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
          sortActionDescription="Sort by device type"
        >
          {{ incidentColumnTitle[IncidentColumn.DEVICE_TYPE] }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >{{ element.deviceType }}
        </td>
      </ng-container>

      <!-- Building Name Column -->
      <ng-container [matColumnDef]="IncidentColumn.BUILDING">
        <th
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
          sortActionDescription="Sort by building name"
        >
          {{ incidentColumnTitle[IncidentColumn.BUILDING] }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          <a
            [class.underline]="!isReportMode"
            [routerLink]="isReportMode ? null : ['/dashboard', element.buildingId]"
          >
            {{ element.building }}
          </a>
        </td>
      </ng-container>

      <!-- Floor Column -->
      <ng-container [matColumnDef]="IncidentColumn.FLOOR">
        <th
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
          sortActionDescription="Sort by floor"
        >
          {{ incidentColumnTitle[IncidentColumn.FLOOR] }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          <a
            [class.underline]="!isReportMode"
            [routerLink]="isReportMode ? null : ['/dashboard', element.buildingId, element.floorId]"
          >{{ element.floor }}</a>
        </td>
      </ng-container>

      <!-- Room Column -->
      <ng-container [matColumnDef]="IncidentColumn.ROOM">
        <th
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
          sortActionDescription="Sort by room"
        >
          {{ incidentColumnTitle[IncidentColumn.ROOM] }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          <a
            [class.underline]="!isReportMode"
            [routerLink]="isReportMode ? null : ['/dashboard', element.buildingId, element.floorId, element.roomId]"
          >{{ element.room }}</a>
        </td>
      </ng-container>

      <!-- Manufacturer Column -->
      <ng-container [matColumnDef]="IncidentColumn.MANUFACTURER">
        <th
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
          sortActionDescription="Sort by manufacturer"
        >
          {{ incidentColumnTitle[IncidentColumn.MANUFACTURER] }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >{{ element.manufacturer }}
        </td>
      </ng-container>

      <!-- Model Column -->
      <ng-container [matColumnDef]="IncidentColumn.MODEL">
        <th
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
          sortActionDescription="Sort by model"
        >
          {{ incidentColumnTitle[IncidentColumn.MODEL] }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >{{ element.model }}
        </td>
      </ng-container>

      <!-- Serial Number Column -->
      <ng-container [matColumnDef]="IncidentColumn.SERIAL_NUMBER">
        <th
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
          sortActionDescription="Sort by serial number"
        >
          {{ incidentColumnTitle[IncidentColumn.SERIAL_NUMBER] }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >{{ element.serialNumber }}
        </td>
      </ng-container>

      <!-- Reported Column -->
      <ng-container [matColumnDef]="IncidentColumn.REPORTED">
        <th
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
          sortActionDescription="Sort by reported"
        >
          {{ incidentColumnTitle[IncidentColumn.REPORTED] }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >{{ element.reported }}
        </td>
      </ng-container>

      <!-- Incident Rule Column -->
      <ng-container [matColumnDef]="IncidentColumn.INCIDENT_RULE">
        <th
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
          sortActionDescription="Sort by incident rule"
        >
          {{ incidentColumnTitle[IncidentColumn.INCIDENT_RULE] }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          {{ element.incidentRule || '-' }}
        </td>
      </ng-container>

      <!-- Resolved Column -->
      <ng-container [matColumnDef]="IncidentColumn.RESOLVED">
        <th
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
          sortActionDescription="Sort by resolved"
        >
          {{ incidentColumnTitle[IncidentColumn.RESOLVED] }}
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          {{ element.resolved || '-' }}
        </td>
      </ng-container>

      <!-- Comments Column -->
      <ng-container
        [matColumnDef]="IncidentColumn.COMMENTS"
        [stickyEnd]="!isMobile"
      >
        <th
          class="table-border-last-right-sticky"
          [class.sticky-end]="!isMobile"
          *matHeaderCellDef
          mat-header-cell
        ></th>
        <td
          class="px-3 table-border-last-right-sticky text-center"
          [class.sticky-end]="!isMobile"
          *matCellDef="let element"
          mat-cell
        >
          <button
            class="icon-btn text-ui-gray-100 hover:text-ui-gray-dark"
            (click)="openNotesDialog(element)"
          >
            @if (element.status === eIncidentStatus.IN_QUEUE) {
              <mat-icon fontIcon="add" />
            } @else {
              <mat-icon fontIcon="chat_bubble_outline" />
            }
          </button>
        </td>
      </ng-container>

      <tr
        *matHeaderRowDef="incidentsFilterService.displayedColumns; sticky: true"
        mat-header-row
      ></tr>

      <tr
        *matRowDef="let row; columns: incidentsFilterService.displayedColumns"
        mat-row
      ></tr>

    </table>
  </cdk-virtual-scroll-viewport-wrapper>
  @if (!dataSource.filteredData.length) {
    <avs-no-data-placeholder
      [hasBigPadding]="isNoDataBigSize"
      [noDataText]="
      incidentsFilterService.incidentTabStatusFilter === incidentTabStatusFilterEnum.HISTORY
        ? noResolvedInicidentsText
        : noDataText"
      [resultContent]="incidentsFilterService.filtersApplied()"
    />
  }

</cdk-virtual-scroll-viewport>
<app-table-zoom
  (zoomChanged)="zoom.set($event)"
  [tableId]="tableId"
/>
